import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import GenerateReport from "./GenerateReport";

const App = () => {
  return (
    <>
      <Router>
        <Routes>
          <Route path="/" element={<GenerateReport />} />
          <Route path="*" element={<GenerateReport />} />
        </Routes>
      </Router>
    </>
  );
};

export default App;
